/* © CNES */
import { Chip } from 'primereact/chip';
import { CollectionDetails } from '../../../../models/CollectionDetails';
import { CollectionHeader } from '../../../explore/RightSidePanel/CollectionHeader/CollectionHeader';
import { LocationTree } from '../../../shared/metadata/LocationTree';
import { ProductDetails } from '../../../shared/metadata/ProductDetails';
import { CustomSection } from './CustomSection/CustomSection';
import './ItemDetails.scss';

/**
 * Item Details displays all metadata for a product.
 * @param collectionDetails CollectionDetails for a product.
 * @param keywords keywords for a product.
 * @returns Element.
 */
export const ItemDetails = ({
  collectionDetails,
}: {
  collectionDetails: CollectionDetails | undefined;
}) => {
  if (!collectionDetails) {
    return null;
  }

  return (
    <div className="ItemDetails">
      <div className="PanelLeft">
        <CustomSection
          title=""
          children={
            <CollectionHeader
              data={{
                name: collectionDetails?.collectionName,
                endDateTime:
                  collectionDetails?.collectionDataModel?.general?.sensingEnd,
                startDateTime:
                  collectionDetails?.collectionDataModel?.general?.sensingStart,
                storageMode:
                  collectionDetails?.collectionDataModel?.general?.storageMode,
                totalSize:
                  collectionDetails?.collectionDataModel?.general?.totalSize,
              }}
            />
          }
        />
        <CustomSection
          title={'Product details'}
          children={
            <ProductDetails
              productDetails={
                collectionDetails?.collectionDataModel?.productDetails
              }
            />
          }
        />
        <CustomSection
          title={'Geometry'}
          children={
            <div className="HeaderRow">
              <p className="RowValue geometry">
                {collectionDetails?.collectionDataModel?.geometry?.multipolygon}
              </p>
            </div>
          }
        />
      </div>
      <div className="PanelRight">
        <CustomSection
          title={'Keywords'}
          children={
            <div className="ChipsContainer">
              {collectionDetails?.collectionDataModel?.keywords?.map(
                (element) => {
                  return (
                    <div key={element}>
                      <Chip className="CustomChip" label={element} />
                    </div>
                  );
                }
              )}
            </div>
          }
        />
        <CustomSection
          title={'Location'}
          children={
            <LocationTree
              locationData={collectionDetails?.collectionDataModel?.location}
            />
          }
        />
      </div>
    </div>
  );
};
